import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((app) => {
  const $router = useRouter();
  const { SENTRY_DSN, SENTRY_ENV, SENTRY_TRACES_SAMPLE_RATE } = useRuntimeConfig().public;

  if (SENTRY_DSN) {
    Sentry.init({
      app: app.vueApp,
      dsn: SENTRY_DSN,
      environment: SENTRY_ENV,
      integrations: [
        Sentry.browserTracingIntegration({ router: $router }),
        Sentry.vueIntegration({
          tracingOptions: {
            trackComponents: true,
          },
        }),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE as number,

      // Disable capturing replays for all sessions
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      ignoreErrors: ["CancelError"],
    });
  }

  return {
    provide: {
      sentry: Sentry,
    },
  };
});
